import React from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';
import { DonutChart } from '../common/DonutChart';

function CircularProgress({ potBalance, potGoal, donutSize }) {
  return (
    <div className="circularProgress text-center">
      <div className="donut">
        <DonutChart
          size={donutSize}
          value={potBalance > 0 ? Math.floor((potBalance / potGoal) * 100) : 0}
        />
        <p>
          <strong>{NumberUtils.appendCurrency('{}', potBalance)}</strong>
          {' of '}
          <strong>{NumberUtils.appendCurrency('{}', potGoal)}</strong>
        </p>
      </div>
    </div>
  );
}

CircularProgress.propTypes = {
  potBalance: PropTypes.number,
  potGoal: PropTypes.number,
  donutSize: PropTypes.number,
};

export { CircularProgress };
